import dynamic from 'next/dynamic';
import { type WithRegularBooking } from '@/components/hocs/withRegularBooking';
import { useState } from 'react';
import { useAvailabilityOptionsDialogContext } from './context';
import AvailabilityOptionsForm, { type SelectedOptionIdByCategory } from '../form';

const ResponsiveDialog = dynamic(() => import('@discover-ui/responsiveDialog'), {
  ssr: false, // avoid server-side errors with the client-only radix-ui components
});

export type AvailabilityOptionsDialogProps = {
  currency: string;
} & Pick<WithRegularBooking, 'handleBooking' | 'isProcessing'>;

export default function AvailabilityOptionsDialog({
  currency,
  handleBooking,
  isProcessing,
}: AvailabilityOptionsDialogProps) {
  const { selectedSlot, selectedRestaurantId, setSelected } = useAvailabilityOptionsDialogContext();
  const [selectedOptionIds, setSelectedOptionIds] = useState<SelectedOptionIdByCategory>({});

  return (
    <ResponsiveDialog
      closeButtonText="Back"
      title="Options"
      description="Select the options for the booking"
      open={!!selectedSlot && !!selectedRestaurantId}
      setOpen={(open) => {
        if (!open) {
          setSelected({ selectedSlot: null, selectedRestaurantId: null });
        }
      }}>
      {selectedSlot?.options && (
        <AvailabilityOptionsForm
          handleBooking={handleBooking}
          isProcessing={isProcessing}
          options={selectedSlot.options}
          selectedOptionIds={selectedOptionIds}
          setSelectedOptionIds={setSelectedOptionIds}
          currency={currency}
        />
      )}
    </ResponsiveDialog>
  );
}
